const overflowStyle = {
  '.overFlowPopUpVisible': {
    position: 'absolute',
    marginTop: '10px',
    zIndex: 9999,
  },
  '.overFlowPopUpHidden': {
    display: 'none',
    position: 'absolute',
  },
};

export default overflowStyle;
